import React from 'react';

/** Текст DP как иконка в навигации (без цветного бейджа). */
const DpMark = () => <span className="nav-text-icon nav-text-icon--dp" aria-hidden="true">DP</span>;

export default DpMark;
